import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import DefaultLayout from '~/pages/_layouts/full';
import Box from '~/components/Box';
import PageTitle from '~/components/PageTitle';
import { Breadcrumb, Select } from 'antd';
import { BreadcrumbCustom } from '~/styles/global';
import ProfitAndLossReport from './ProfitAndLossReport';
import EstimatedActualReport from './EstimatedActualReport';
import ProfitAndLossDetailReport from './ProfitAndLossDetailReport';
import CashFlowReport from './CashFlowReport';

const { Option } = Select;

export default function Reports() {
  const { t } = useTranslation();
  const [selectedReport, setSelectedReport] = useState('ProfitAndLoss');

  const handleReportChange = value => {
    setSelectedReport(value);
  };

  const breadcrumb = (
    <BreadcrumbCustom>
      <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
      <Breadcrumb.Item>Reports</Breadcrumb.Item>
    </BreadcrumbCustom>
  );

  return (
    <DefaultLayout breadcrumb={breadcrumb}>
      <Box>
        <PageTitle title="Reports" />
        <div style={{ marginBottom: 16 }}>
          <Select
            value={selectedReport}
            style={{ width: 200 }}
            onChange={handleReportChange}
          >
            <Option value="CashFlow">{t('screens:reports.cashFlow')}</Option>
            <Option value="ProfitAndLoss">{t('screens:reports.profitAndLoss')}</Option>
            <Option value="ProfitAndLossDetail">{t('screens:reports.profitAndLossDetail')}</Option>
            <Option value="EstimatedActual">{t('screens:reports.estimatedActual')}</Option>
            {/* Future reports can be added here */}
          </Select>
        </div>
        {selectedReport === 'CashFlow' && <CashFlowReport />}
        {selectedReport === 'ProfitAndLoss' && <ProfitAndLossReport />}
        {selectedReport === 'ProfitAndLossDetail' && <ProfitAndLossDetailReport />}
        {selectedReport === 'EstimatedActual' && <EstimatedActualReport />}
      </Box>
    </DefaultLayout>
  );
}